import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { timer } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { AuthService } from 'app/api/auth.service';

@Directive({
  selector: '[password]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: PasswordDirective, multi: true }
  ]
})
export class PasswordDirective {
  constructor(private auth: AuthService) {}
  level = 3;
  validate(control: AbstractControl): { [key: string]: any } {
    return timer(200).pipe(
      switchMap(() => this.auth.postCheckPassword(control.value || '')),
      map(({ score, feedback }: any) =>
        score < this.level
          ? {
              strength: score,
              suggestions: [feedback.warning, ...feedback.suggestions]
            }
          : null
      )
    );
  }
}
